import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from './SiteSettingsContext';

const CANONICAL_BASE = 'https://salonidesigns.com';

const PAGE_META = {
  home: {
    path: '/',
    fallbackTitle: 'Handcrafted Jewelry Online | Saloni Designs — Rakhi, Lumba & More',
    fallbackDescription:
      'Shop handcrafted Rakhi, Lumba, bracelets, necklaces & festive jewelry at Saloni Designs. Authentic designs — shipped across India.',
  },
  shop: {
    path: '/shop',
    fallbackTitle: 'Shop Handcrafted Jewelry Collections | Saloni Designs',
    fallbackDescription:
      'Browse Rakhi, Lumba, bracelets, necklaces & more. Handcrafted Indian jewelry — shipped across India.',
  },
  contact: {
    path: '/contact',
    fallbackTitle: 'Contact Saloni Designs | Handcrafted Jewelry & Rakhi',
    fallbackDescription:
      'Contact Saloni Designs for orders, custom jewelry, and enquiries. Call, email, or WhatsApp — we ship across India.',
  },
  about: {
    path: '/about',
    fallbackTitle: 'About Saloni Designs | Handcrafted Jewelry & Rakhi',
    fallbackDescription:
      'Learn about Saloni Designs — handcrafted jewelry rooted in tradition, made with care and shipped across India.',
  },
};

/**
 * @param {{ page: 'home'|'shop'|'contact'|'about', children?: React.ReactNode }} props
 */
export default function PageSeoHelmet({ page, children }) {
  const { settings: site } = useSiteSettings();
  const meta = PAGE_META[page] || PAGE_META.home;
  const prefix = `seo_${page}`;

  const title = String(site[`${prefix}_title`] || '').trim() || meta.fallbackTitle;
  const description =
    String(site[`${prefix}_description`] || '').trim() || meta.fallbackDescription;
  const ogImage = String(site[`${prefix}_og_image`] || '').trim();
  const canonical = `${CANONICAL_BASE}${meta.path}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      </Helmet>
      {children}
    </>
  );
}
